import axios from "axios";

export default function ProjectWarehouseCreateService(projectId) {
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/project/" + projectId + "/create_warehouse",
    data: {},
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
